import { i18n } from '@/commons/utils';

const MERGE_INFO_MESSAGE = 'cart.cartdetails.header.theProductsThatWereAlreadyInYourShoppingCartAtPreviousVisitsHaveAutomaticallyBeenAdded';
const EXCEEDED_THRESHOLD_MESSAGE = 'cart.cartdetails.header.afterMergeTotalItemsPerOrderExceededThreshold1000SoItemQuantityHasBeenReinitializedAt1';
const MERGE_INFO_TIMEOUT = 5000;

export function init() {
  $(window).load(() => {
    const $body = $('body');
    if ($body.data('isMerged') === true) {
      showMergeInfo();
    }
  });
}

export function showMergeInfo() {
  $('body').pushAlert({
    type: 'info',
    text: i18n(MERGE_INFO_MESSAGE),
    delay: MERGE_INFO_TIMEOUT
  });
}

export function showTriggeredMaxItemsThresholdDuringMergeInfo() {
  $('body').pushAlert({
    type: 'info',
    text: i18n(EXCEEDED_THRESHOLD_MESSAGE)
  });
}



// WEBPACK FOOTER //
// ./src/checkout/cart/cart-merge.js